import { useEffect, useState } from "react";

export const useAuth = () => {
  const [auth, setAuth] = useState({ loading: true, isAuthenticated: false, user: null });

  useEffect(() => {
    const token = localStorage.getItem("google_token");
    if (!token) {
      setAuth({ loading: false, isAuthenticated: false });
      return;
    }


    fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=${token}`)
      .then((res) => {
        if (!res.ok) throw new Error("Invalid token");
        return res.json();
      })
      .then((data) => {

        console.log("DATA", data);
        setAuth({ loading: false, isAuthenticated: true, user: data });
      })
      .catch(() => {
        localStorage.clear();
        setAuth({ loading: false, isAuthenticated: false });
      });
  }, []);

  return auth;
};
